let timeToEndPDP;
let countDownDatePDP;
const countdownTimerPDP = () => {
    Array.from(document.querySelectorAll('[data-pdp-countdown-message]')).map((countdown) => {
        //Get the date set in Shopify
        const date = new Date(countdown.attributes['data-pdp-countdown-endtime'].value);
        //When countdown is enabled
        if (countdown.attributes['data-pdp-countdown-message']) {
            const contentDiv = countdown.querySelector('[data-pdp-countdown-message-text]');
            const contentText = contentDiv.innerText;
            const splitContent = contentText.split('[CD]');
            countDownDatePDP = date.getTime();
            const now = new Date().getTime();
            timeToEndPDP = countDownDatePDP - now;
            if (timeToEndPDP >= 0) {
                contentDiv.classList.add('show');
                contentDiv.innerHTML = splitContent.join(getCountDownStringPDP());
            }
            else if (timeToEndPDP <= 0) {
                contentDiv.classList.remove('show');
                countdown.remove();
            }
            const countDownTimer = setInterval(() => {
                contentDiv.innerHTML = splitContent.join(getCountDownStringPDP());
                //If the countdown has ended, revert to default
                if (timeToEndPDP <= 0) {
                    contentDiv.classList.remove('show');
                    countdown.remove();
                    clearInterval(countDownTimer);
                }
            }, 1000);
        }
    });
};
const getCountDownStringPDP = () => {
    const now = new Date().getTime();
    timeToEndPDP = countDownDatePDP - now;
    const days = Math.floor(timeToEndPDP / (1000 * 60 * 60 * 24));
    const hours = Math.floor((timeToEndPDP % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((timeToEndPDP % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeToEndPDP % (1000 * 60)) / 1000);
    let dayString;
    if (days > 0) {
        dayString = `${days}D`;
    }
    else {
        dayString = '';
    }
    let hoursString;
    if (hours > 0) {
        hoursString = ` ${hours}H`;
    }
    else {
        hoursString = '';
    }
    const minutesString = ` ${minutes}M`;
    const secondsString = `${seconds < 10 ? ` 0${seconds}S` : ` ${seconds}S`}`;
    return `${dayString}${hoursString}${minutesString}${secondsString}`;
};
countdownTimerPDP();
